"use in client"

import { useCallback } from "react"
import Particles from "react-particles"
import { loadSlim } from "tsparticles-slim"

const ParticleBackground = () => {
  const particlesInit = useCallback(async (engine) => {
    // This loads the tsparticles engine
    await loadSlim(engine)
  }, [])

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      options={{
        background: {
          color: {
            value: "transparent", // Keep transparent to show the global gradient
          },
        },
        fpsLimit: 120,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "push",
            },
            onHover: {
              enable: true,
              mode: "repulse",
            },
            resize: true,
          },
          modes: {
            push: {
              quantity: 4,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
          },
        },
        particles: {
          // --- Modified Section ---
          color: {
            // Use an array of colors from your new palette for the particles
            value: ["#264653", "#2A9D8F", "#E9C46A"],
          },
          links: {
            // Links will randomly pick a color from the connected particles
            color: "random",
            distance: 150,
            enable: true,
            opacity: 0.25, // Slightly increased for better visibility on the gradient
            width: 1,
          },
          // --- End of Modified Section ---
          collisions: {
            enable: true,
          },
          move: {
            direction: "none",
            enable: true,
            outModes: {
              default: "bounce",
            },
            random: false,
            speed: 1, // Kept slow for a subtle, elegant effect
            straight: false,
          },
          number: {
            density: {
              enable: true,
              area: 800,
            },
            // Reduced particle count for a cleaner, less cluttered look
            value: 80,
          },
          opacity: {
            value: 0.4, // Slightly increased opacity
          },
          shape: {
            type: "circle",
          },
          size: {
            value: { min: 1, max: 3 },
          },
        },
        detectRetina: true,
      }}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: -1, // Keep behind all other content
      }}
    />
  )
}

export default ParticleBackground